import { render, staticRenderFns } from "./profile-picture.vue?vue&type=template&id=d38c1090"
import script from "./profile-picture.vue?vue&type=script&lang=js"
export * from "./profile-picture.vue?vue&type=script&lang=js"
import style0 from "./profile-picture.vue?vue&type=style&index=0&id=d38c1090&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports